// extracted by css-extract-rspack-plugin
export default {"IconButton":"group-menu-module__IconButton__Mmcar"};